// Ducks: actions, types, reducer (Reduxsauce 2.x)
// Padrão do projeto: Creators exportados e reducer default

import { createActions, createReducer } from 'reduxsauce';
import initialState from './model.js';

// Actions & Types
export const { Types, Creators } = createActions({
  // Async (saga)
  tradeInSimulationsCreateAsync: ['payload'], // { ...formData }
  tradeInSimulationsFetchAsync: null,
  tradeInSimulationsUpdateStatusAsync: ['id', 'status'], // status: "Solicitado" | "Atendido" | "Finalizado"

  // Success/Failure
  tradeInSimulationsCreateSuccess: ['id'],
  tradeInSimulationsCreateFailure: ['error'],

  tradeInSimulationsFetchSuccess: ['list'],
  tradeInSimulationsFetchFailure: ['error'],

  tradeInSimulationsUpdateStatusSuccess: ['id', 'status'],
  tradeInSimulationsUpdateStatusFailure: ['error'],

  tradeInSimulationsClearError: null,
});

// Reducer handlers
const createAsync = (state) => ({
  ...state,
  creating: true,
  error: null,
});

const createSuccess = (state) => ({
  ...state,
  creating: false,
});

const createFailure = (state, { error }) => ({
  ...state,
  creating: false,
  error,
});

const fetchAsync = (state) => ({
  ...state,
  listLoading: true,
  error: null,
});

const fetchSuccess = (state, { list }) => ({
  ...state,
  listLoading: false,
  list: Array.isArray(list) ? list : [],
});

const fetchFailure = (state, { error }) => ({
  ...state,
  listLoading: false,
  error,
});

const updateStatusAsync = (state) => ({
  ...state,
  updatingStatus: true,
  error: null,
});

const updateStatusSuccess = (state, { id, status }) => ({
  ...state,
  updatingStatus: false,
  // Atualiza localmente (otimista). Saga também pode refazer o GET após sucesso.
  list: state.list.map((x) => (x.id === id ? { ...x, status } : x)),
});

const updateStatusFailure = (state, { error }) => ({
  ...state,
  updatingStatus: false,
  error,
});

const clearError = (state) => ({
  ...state,
  error: null,
});

// Root reducer
export default createReducer(initialState, {
  [Types.TRADE_IN_SIMULATIONS_CREATE_ASYNC]: createAsync,
  [Types.TRADE_IN_SIMULATIONS_CREATE_SUCCESS]: createSuccess,
  [Types.TRADE_IN_SIMULATIONS_CREATE_FAILURE]: createFailure,

  [Types.TRADE_IN_SIMULATIONS_FETCH_ASYNC]: fetchAsync,
  [Types.TRADE_IN_SIMULATIONS_FETCH_SUCCESS]: fetchSuccess,
  [Types.TRADE_IN_SIMULATIONS_FETCH_FAILURE]: fetchFailure,

  [Types.TRADE_IN_SIMULATIONS_UPDATE_STATUS_ASYNC]: updateStatusAsync,
  [Types.TRADE_IN_SIMULATIONS_UPDATE_STATUS_SUCCESS]: updateStatusSuccess,
  [Types.TRADE_IN_SIMULATIONS_UPDATE_STATUS_FAILURE]: updateStatusFailure,

  [Types.TRADE_IN_SIMULATIONS_CLEAR_ERROR]: clearError,
});
